/* eslint-disable @typescript-eslint/indent */

/* Note: please be careful with indentation, we have the rule disabled because of
*  eslint not being able to properly indent js inside styled components
*/

// Core
import styled from 'styled-components';

// Plugins
import { BREAKPOINTS } from '../../config/screen';

export const Layout = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.color.mainNavigation.borderBottomColor};
  padding: 1rem;
  background-color: ${({ theme }) => theme.color.mainNavigation.mainNavigationNavBgColor};

  .ant-menu {
    line-height: 64px;
    border-bottom: none;
    background-color: transparent;
    width: 100%;
    display: none;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding: 0 2.75rem;

    .ant-menu {
      display: flex;
    };
  };

  .ant-menu-item {
    display: flex;
    align-items: center;
    gap: 6px;
  };

  .ant-menu-title-content {
    font-family: ${({ theme }) => theme.font.bold};
    color: ${({ theme }) => theme.color.mainNavigation.mainNavigationTextColor};
    font-size: 0.875rem;
    font-style: normal;
  };

  .ant-menu-item:hover svg {
    color: ${({ theme }) => theme.color.mainNavigation.menuItemHoverIconColor};
  };

  .ant-menu-item-selected .ant-menu-title-content {
    color: ${({ theme }) => theme.color.mainNavigation.selectedItemTextColor};
  };

  .ant-menu-item:hover > .ant-menu-title-content {
    color: ${({ theme }) => theme.color.mainNavigation.selectedItemTextColor};
  };

  .ant-menu-horizontal > .ant-menu-item:hover::after {
    border-bottom-width: 0;
    border-bottom-color: ${({ theme }) => theme.color.mainNavigation.menuBorderBottomColor};
  };

  .ant-menu-horizontal > .ant-menu-item::after {
    inset-inline: 0;
  };

  .ant-menu-horizontal > .ant-menu-submenu-selected::after {
    border-bottom-width: 1px;
    inset-inline: 2px;
  };

  .ant-menu-overflow-item {
    padding: 0 1.5rem 0.25rem 1.25rem;
  };

  .ant-menu-item-title {
    white-space: nowrap;
  };

  .ant-menu-light.ant-menu-horizontal > .ant-menu-item-selected::after {
    border-bottom: 1px solid ${({
      theme,
    }) => theme.color.mainNavigation.menuBorderBottomColor} !important;
  };

  .ant-menu-light.ant-menu-horizontal > .ant-menu-item:hover::after {
    border-bottom: 1px solid ${({ theme }) => theme.color.mainNavigation.menuBorderBottomColor};
  };

  .ant-menu-light.ant-menu-horizontal > .ant-menu-item::after {
    border-bottom: 1px solid transparent;
  };
`;

export const NavigationContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const LeftSection = styled.div`
  height: 100%;
  width: max-content;
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  min-height: 100%;
  justify-content: flex-end;
  gap: 34px;
`;

/* Desktop Elements */

export const Actions = styled.div`
  display: flex;
  align-items: center;
`;

export const AvatarContainer = styled.div`
  color: ${({ theme }) => theme.color.mainNavigation.mainNavigationIconsColor};
  display: flex;
  margin-right: 0.125rem;

  svg {
    width: 22px !important;
    height: 22px !important;
  };
`;

export const CaretDownContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MenuButton = styled.button`
  background-color: transparent;
  border: none;
  color: ${({ theme }) => theme.color.mainNavigation.mainNavigationIconsColor};
  cursor: pointer;
  width: max-content;
  height: max-content;

  svg {
    width: 24px;
    height: 24px;
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    display: none;
  };
`;

export const SearchContainer = styled.div`
  /* Base (xxs) */
  display: none;
  width: 100%;

  @media (min-width: ${BREAKPOINTS.md}px) {
    display: block;
  };
`;

export const UserActions = styled.div`
  display: flex;
  gap: 18px;
  align-items: center;
  
  /* Padding only for desktop */
  padding-left: 0;

  @media (min-width: ${BREAKPOINTS.md}px) {
    padding-left: 2rem;
  };
`;

export const OptionsDropdownContainer = styled.div`
  color: ${({ theme }) => theme.color.mainNavigation.caretDownColor};
  align-items: center;
  
  /* Hidden on mobile */
  display: none;

  @media (min-width: ${BREAKPOINTS.md}px) {
    display: flex; /* Visible on desktop */
  };

  > div > div {
    display: flex;
    flex-direction: row;
  };

  .ant-dropdown-open {
    > div:nth-child(2) {
      transform: rotate(-180deg);
      transition: transform 0.3s ease-in-out;
    };
  };

  .ant-dropdown-trigger {
    > div:nth-child(2) {
      transition: transform 0.3s ease-in-out;
    };
  };
`;

  /* ***********************************************************************************************
  **************************************** MOBILE STYLES *******************************************
  *********************************************************************************************** */

export const MobileMenuContainer = styled.div<{ isOpen: boolean }>`
  background-color: ${({ theme }) => theme.color.mainNavigation.mainNavigationNavBgColor};
  display: flex;
  flex-direction: column;
  height: 100dvh;
  left: 0;
  position: fixed;
  top: 0;
  transform: ${({ isOpen }) => (isOpen ? 'translateX(0)' : 'translateX(-100%)')};
  transition: transform 0.3s ease-in-out;
  width: 100dvw;
  z-index: 1000;

  .ant-menu {
    background-color: transparent;
    border: none;
    display: flex;
    flex-direction: column;
    line-height: 48px;
    width: 100%;
    border-inline-end: none !important;
    box-sizing: border-box;
    gap: 4px;
    border-bottom: 1px solid ${({ theme }) => theme.color.mainNavigation.borderBottomColor};
  };

  .ant-menu-item {
    padding: 0 1rem !important;
    display: flex;
    align-items: center;
    gap: 4px;
    margin: 0;
    width: 100%;
  };

  .ant-menu-item:first-child {
    margin-top: 0.625rem;
  };

  .ant-menu-item:last-child {
    margin-bottom: 0.625rem;
  };

  .ant-menu-title-content {
    font-family: ${({ theme }) => theme.font.bold};
    color: ${({ theme }) => theme.color.mainNavigation.mainNavigationTextColor};
    font-size: 1rem;
    font-style: normal;
  };

  .ant-menu-light:not(.ant-menu-horizontal) .ant-menu-item:not(.ant-menu-item-selected):hover {
    background-color: ${({ theme }) => theme.color.mainNavigation.menuItemHoverBackgroundColor};
  };

  .ant-menu-item-selected .ant-menu-title-content {
    color: ${({ theme }) => theme.color.mainNavigation.selectedItemTextColor};
  };

  .ant-menu-item:hover:not(.ant-menu-item-selected) > .ant-menu-title-content {
    color: ${({ theme }) => theme.color.mainNavigation.menuItemHoverIconColor};
  };

  .ant-menu-item-selected {
    background-color: ${({ theme }) => theme.color.mainNavigation.menuItemSelectedBackgroundColor};
  };
  
  .ant-menu-item-selected .ant-menu-title-content {
    color: ${({ theme }) => theme.color.mainNavigation.menuItemSelectedTextColor};
  };

  .ant-menu-item svg {
    height: 18px;
    width: 18px;
  };

  .ant-menu-item:hover svg {
    color: ${({ theme }) => theme.color.mainNavigation.menuItemHoverIconColor};
  };

  .ant-menu-item:hover {
    background-color: ${({ theme }) => theme.color.mainNavigation.menuItemHoverBackgroundColor};
  };

  .ant-menu-item:active {
    background-color: ${({ theme }) => theme.color.mainNavigation.menuItemHoverBackgroundColor} !important;
  };

  .ant-menu-title-content {
    color: ${({ theme }) => theme.color.mainNavigation.menuItemDefaultTextColor};
  };

  @media (min-width: ${BREAKPOINTS.md}px) {
    display: none;
  };
`;

export const MobileMenuHeader = styled.div`
  align-items: center;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.color.mainNavigation.borderBottomColor};
`;

export const MobileMenuBody = styled.div`
  padding: 0 1rem;
`;

export const MobileMenuFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 1rem;
  gap: 8px;

  > button {
    align-items: center;
    display: flex;
    width: 100%;
    height: 40px;

    :hover {
      background-color: ${({
        theme,
      }) => theme.color.mainNavigation.mobileMenuFooterButtonHoverBackgroundColor};
      border-radius: 4px;
    };
  };

  > button > svg {
    align-items: center !important;
    margin-top: 0.125rem;
  };
`;

export const MobileMenuFooterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0.75rem 1rem;
  text-align: left;
  width: 100%;
  font-family: ${({ theme }) => theme.font.bold};
  color: ${({ theme }) => theme.color.mainNavigation.mainNavigationTextColor};
  font-size: 1rem;

  svg {
    width: 20px;
    height: 20px;
    color: ${({ theme }) => theme.color.mainNavigation.mainNavigationIconsColor};
  };

  &:hover {
    color: ${({ theme }) => theme.color.mainNavigation.selectedItemTextColor};

    svg {
      color: ${({ theme }) => theme.color.mainNavigation.selectedItemTextColor};
    };
  };
`;

export const MobileMenuCloseButton = styled.button`
  align-items: center;
  background-color: transparent;
  border: none;
  color: ${({ theme }) => theme.color.mainNavigation.mainNavigationIconsColor};
  cursor: pointer;
  display: flex;

  svg {
    width: 24px;
    height: 24px;

    :hover {
      color: ${({ theme }) => theme.color.mainNavigation.menuCloseButtonHoverColor};
    };
  };
`;
